import { PostponeStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<PostponeStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      dialog: ['dialog'],
      text: ['message', 'condition']
    })
  )
}
